import en from './en';

export const restrictedTranslations: NamespaceTranslations<keyof typeof en> = {
  en,
};
